import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import endPoint from "../redux/EndPoint/endpoint";
import LoaderPage from "./Loader";
import Footer from "../Fotter";

const Blogs = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState("All");
    const [categories, setCategories] = useState([]);
    const [categoriesId, setCategoriesId] = useState('')

    useEffect(() => {
        const getBlogs = async () => {
            try {
                const response = await axios.get(`${endPoint.GetBlogs}`);
                setBlogs(response?.data || []);
                setFilteredBlogs(response?.data || []);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            } finally {
                setLoading(false);
            }
        };

        getBlogs();
    }, []);

    useEffect(() => {
        const getCategory = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`${endPoint.GetBlogCategory}`);
                setCategories(res?.data?.data || []);
            } catch (err) {
                console.log("err", err);
            } finally {
                setLoading(false);
            }
        };

        getCategory();
    }, []);

    const generateSlug = (title) => {
        return title
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^\u0900-\u097F\w-]+/g, "")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "");
    };

    const handleCategoryClick = (categoryName) => {
        setActiveCategory(categoryName?.name);
        setCategoriesId(categoryName?._id)
        if (categoryName?.name === "All") {
            setFilteredBlogs(blogs);
        } else {
            const filtered = blogs?.filter(
                (blog) => blog.category?.toLowerCase() === categoryName?.name?.toLowerCase()
            );
            setFilteredBlogs(filtered);
        }
    };

    useEffect(() => {
        const getCategoryId = async () => {
            if (!categoriesId) return;
            try {
                setLoading(true)
                const res = await axios.get(
                    `${endPoint.GetCategoryById}/${categoriesId}`
                );
                setFilteredBlogs(res?.data?.blogs || []);
            } catch (err) {
                console.error("Error fetching category by ID:", err);
            }
            finally {
                setLoading(false)
            }
        };

        getCategoryId();
    }, [categoriesId]);

    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            <div className="flex-grow">
                <div className="w-full md:max-w-[90%] mx-auto px-4 py-8">
                    <h1 className="text-4xl font-bold mb-8 text-center">Latest Blogs</h1>

                    <div className="flex flex-wrap justify-center gap-3 mb-8">
                        <button
                            key="all"
                            onClick={() => handleCategoryClick("All")}
                            className={`px-4 py-2 rounded-full text-sm font-medium transition 
                ${activeCategory === "All"
                                    ? "bg-blue-600 text-white"
                                    : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                                }`}
                        >
                            All
                        </button>

                        {categories?.map((cat) => (
                            <button
                                key={cat._id}
                                onClick={() => handleCategoryClick(cat)}
                                className={`px-4 py-2 rounded-full text-sm font-medium transition 
                  ${activeCategory === cat.name
                                        ? "bg-blue-600 text-white"
                                        : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                                    }`}
                            >
                                {cat.name}
                            </button>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        {filteredBlogs && filteredBlogs?.length > 0 ? (
                            filteredBlogs?.map((blog) => {
                                const isVideo =
                                    blog.media?.endsWith(".mp4") || blog.media?.includes("video");
                                return (
                                    <div
                                        key={blog?._id}
                                        className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer"
                                        onClick={() =>
                                            navigate(
                                                `/Blogs/${encodeURIComponent(generateSlug(activeCategory))}/${encodeURIComponent(generateSlug(blog?.title))}`
                                            )
                                        }
                                    >
                                        {isVideo ? (
                                            <video
                                                src={blog?.media}
                                                controls
                                                className="w-full h-48 object-cover"
                                            />
                                        ) : (
                                            <img
                                                src={
                                                    blog?.media || "https://via.placeholder.com/400x250"
                                                }
                                                alt={blog?.title}
                                                className="w-full h-48 object-cover"
                                            />
                                        )}

                                        <div className="p-4">
                                            <h2 className="text-xl font-semibold mb-2">
                                                {blog?.title}
                                            </h2>

                                            <h2
                                                className="text-gray-600 text-sm mb-4 line-clamp-2"
                                                dangerouslySetInnerHTML={{
                                                    __html: blog.content?.slice(0, 100) + "...",
                                                }}
                                            ></h2>
                                            <span className="text-blue-600 font-medium hover:underline">
                                                Read More →
                                            </span>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-span-full text-center py-10">
                                <p className="text-gray-600 text-lg">
                                    No blogs available in this category.
                                </p>
                            </div>
                        )}
                    </div>

                    {loading && <LoaderPage />}
                </div>
            </div>
            <Footer className="fixed" />
        </div>
    );
};

export default Blogs;
